<!-- Material theme menu voor mobiel-->
@if (mobile) {
  <button matTooltip="{{ 'tooltip.settings' | translate }}" #tooltip="matTooltip" mat-menu-item [matMenuTriggerFor]="setting_menu">
    <mat-icon>
      settings
    </mat-icon>
    <!--{{ 'mainapp.buttons.settings' | translate}}-->
  </button>
}

@if (mobile) {
  <button mat-menu-item [matMenuTriggerFor]="helpmenu">
    <mat-icon>
      help
    </mat-icon>
    <!--{{ 'mainapp.buttons.settings' | translate}}-->
  </button>
}

<!-- Material theme menu -->
@if (mobile && appConfigArray.length > 1) {
  <button mat-menu-item [matMenuTriggerFor]="change_app">
    <mat-icon>compare_arrows</mat-icon>
  </button>
}

@if (mobile && showOrganisations) {
  <button mat-menu-item [matMenuTriggerFor]="change_org">
    <mat-icon>
      sd_card
    </mat-icon>
    <!--{{ 'mainapp.buttons.settings' | translate}}-->
  </button>
}

<mat-menu #change_app="matMenu">
  @for (appconf of appConfigArray; track appconf) {
    <button (click)="changeApp(appconf)" mat-menu-item >
      <span>{{appconf.name}}</span>
    </button>
  }
</mat-menu>

@if (!mobile) {
  <button [disableRipple]="true" mat-button style="border: none; outline: none; background-color: transparent; margin-right: 20px;padding-left: 0px;">
    @if (!mobile) {
      <app-merkator-googlelocator >
      </app-merkator-googlelocator>
    }
  </button>
}





<!-- Material theme menu voor niet mobiel -->
@if (!mobile) {
  <button matTooltip="{{ 'tooltip.settings' | translate }}" #tooltip="matTooltip" mat-button [matMenuTriggerFor]="setting_menu">
    <mat-icon>
      settings
    </mat-icon>
    <!--{{ 'mainapp.buttons.settings' | translate}}-->
  </button>
}

<!-- Material theme menu -->
@if (!mobile) {
  <button matTooltip="{{ 'tooltip.questions' | translate }}" #tooltip="matTooltip" mat-button [matMenuTriggerFor]="helpmenu">
    <mat-icon>
      help
    </mat-icon>
    <!--{{ 'mainapp.buttons.settings' | translate}}-->
  </button>
}

<!-- Material theme menu -->
@if (!mobile && appConfigArray.length > 1) {
  <button matTooltip="{{ 'tooltip.switchwithinorg' | translate }}" #tooltip="matTooltip" mat-button [matMenuTriggerFor]="change_app">
    <mat-icon>
      compare_arrows
    </mat-icon>
    <!--{{ 'mainapp.buttons.settings' | translate}}-->
  </button>
}

<!-- Material theme menu -->
@if (!mobile && showOrganisations) {
  <button matTooltip="{{ 'tooltip.switchorg' | translate }}" #tooltip="matTooltip" mat-button [matMenuTriggerFor]="change_org">
    <mat-icon>
      sd_card
    </mat-icon>
    <!--{{ 'mainapp.buttons.settings' | translate}}-->
  </button>
}

<!-- release notes, help, about merkator, pdf met baseline-->
<mat-menu #helpmenu="matMenu">

  <button (click)="whatsNew();" mat-menu-item>
    <mat-icon>new_releases</mat-icon>
    {{ 'toolbar.settings.whatsnew' | translate }}
  </button>
  <button (click)="openSupport();" mat-menu-item>
    <mat-icon>contact_support</mat-icon>
    {{ 'toolbar.settings.support' | translate }}
  </button>
  <button (click)="openBaseline();" mat-menu-item>
    <mat-icon>policy</mat-icon>
    {{ 'toolbar.settings.baseline' | translate }}
  </button>
  <button (click)="openMerkator();" mat-menu-item>

    <!-- add merkator image -->
    <img style="margin-top: 7px; margin-right: 10px;" src="../../../../assets/merkatorlogo.png" height="24" width="24">
    {{ 'toolbar.settings.about' | translate }}
  </button>

</mat-menu>

<!--
"usermanagement": "Usermanagement",
"whatsnew": "What's new?",
"theme": "Colortheme",
"language": "Language",
"about": "About Merkator",
"support": "Contact support",
"baseline": "Download baseline"
-->

<mat-menu #change_org="matMenu">
  <mat-form-field (click)="$event.stopPropagation()" style="max-width: 80%;padding-left: 10px;">
    <input #input matInput placeholder="Filter" value="" (keyup)="filterMyArray(input.value);">
  </mat-form-field>
  @for (organisation of showArray; track organisation) {
    <button (click)="changeOrg(organisation.id)" mat-menu-item >
      <span>{{organisation.name}}</span>
    </button>
  }
</mat-menu>


<mat-menu #setting_menu="matMenu">

  <!-- Logging menu -->
  @if (appService.hasAdminPower) {
    <button (click)="openLogGrid();" mat-menu-item>
      <mat-icon>assignment</mat-icon>
      {{ 'toolbar.settings.logging' | translate }}
    </button>
  }

  <!-- Language menu -->
  <button mat-menu-item [matMenuTriggerFor]="menu_language">
    <mat-icon>language</mat-icon>
    {{ 'toolbar.settings.language' | translate }}
  </button>
  <mat-menu #menu_language="matMenu">
    @for (language of availableLanguages; track language) {
      <button (click)="changeLanguage(language)" mat-menu-item
        [disabled]="currentActiveLanguage == language ? true : false">
        <span fi fi-{{language}}></span>
        {{language | uppercase}}
      </button>
    }
  </mat-menu>

  <!-- Material theme menu -->
  <button mat-menu-item [matMenuTriggerFor]="menu_palette">
    <mat-icon>palette</mat-icon>
    {{ 'toolbar.settings.theme' | translate }}
  </button>
  <mat-menu #menu_palette="matMenu">
    <button (click)="changeTheme('light-theme')" mat-menu-item [disabled]="theme == 'light-theme' ? true : false">
      <span>{{ 'toolbar.settings.lighttheme' | translate }}
      </span>
    </button>
    <button (click)="changeTheme('dark-theme')" mat-menu-item [disabled]="theme == 'dark-theme' ? true : false">
      <span>{{ 'toolbar.settings.darktheme' | translate }}</span>
    </button>
  </mat-menu>

  <!-- Account theme menu -->
  @if (appService.hasAdminPower) {
    <button mat-menu-item [matMenuTriggerFor]="account_">
      <mat-icon >account_box</mat-icon>
      {{ 'toolbar.settings.usermanagement' | translate }}
    </button>
  }
  <mat-menu #account_="matMenu">
    <button (click)="openUserManagement()" mat-menu-item >
      <span>{{ 'toolbar.settings.usermanagement' | translate }}</span>
    </button>
  </mat-menu>
  <!-- Account theme menu -->
  <button (click)="logoffAndRevokeTokens()" mat-menu-item>
    <mat-icon >logout</mat-icon>
    {{ 'toolbar.settings.logout' | translate }}
  </button>




</mat-menu>